// src/components/GenericModal.jsx
import React from 'react';
import '../assets/css/genericModal.css';
const GenericModal = ({ 
  isOpen, 
  onClose, 
  title, 
  children,
  className = ''
}) => {
  return (
    <div className={`modal-overlay ${isOpen ? 'active' : ''}`} onClick={onClose}>
      <div 
        className={`modal-content ${className}`} 
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3 className="modal-title">{title}</h3>
          <button 
            className="close-btn"
            onClick={onClose}
          >
            <i className="fas fa-times"></i>
          </button>
        </div>
        
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default GenericModal;